import React from 'react';

function SitePattern({name, pattern, url}: {name: string; pattern: string; url: string}): JSX.Element {
  return (
    <div>
      {name} <span style={{fontFamily: 'monospace'}}>{pattern}</span> (
      <a href={url} target="_blank" rel="noopener noreferrer">
        Reference
      </a>
      )
    </div>
  );
}

export function LiabilitySitesDescription(): JSX.Element {
  return (
    <div className="alert alert-info">
      <SitePattern
        name="N-Linked Glycosylation pattern:*"
        pattern="N_[S|T]"
        url="https://prosite.expasy.org/PDOC00001"
      />
      <SitePattern
        name="Asparagine Deamidation pattern:"
        pattern="NG|NS|NT|NN"
        url="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4069079/"
      />
      <SitePattern
        name="Asparagine Deamidation (in CDRs) pattern:**"
        pattern="N"
        url="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6343770/"
      />
      <SitePattern
        name="Methionine Oxidation pattern:"
        pattern="M"
        url="https://www.ncbi.nlm.nih.gov/pubmed/18407665"
      />
      <SitePattern
        name="Tryptophan Oxidation pattern:"
        pattern="W"
        url="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6290686/"
      />
      <SitePattern
        name="Aspartate Isomerization pattern:"
        pattern="DG|DS|DT|DD|DH"
        url="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4069079/"
      />
      <div style={{marginTop: 10, fontSize: '80%'}}>
        * Where the blank is any single AA except Pro <br />
        ** Instances of deamidation modifications on non-canonical motifs have been documented across all
        CDRs. Enabling this site will flag all Asn’s that reside within an identified CDR region, as defined
        by your CDR Annotations visibility setting.
      </div>
    </div>
  );
}
